/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-extraneous-dependencies */
import { SimpleSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { DocumentLoadInstrumentation } from '@opentelemetry/instrumentation-document-load';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { LoggerProvider, SimpleLogRecordProcessor } from '@opentelemetry/sdk-logs';
import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http';
import { logs } from '@opentelemetry/api-logs';
import { server } from './config';

const { traceUrl, logsUrl } = server;

const otlpExporter = new OTLPTraceExporter({
  url: traceUrl,
});

const resource = resourceFromAttributes({
  'service.name': window.location.hostname === 'cs.justdial.com' ? 'csportal_prod' : 'csportal_dev',
});

const provider = new WebTracerProvider({
  resource,
  spanProcessors: [new SimpleSpanProcessor(otlpExporter)],
});

provider.register({
  contextManager: new ZoneContextManager(),
});

registerInstrumentations({
  instrumentations: [
    new DocumentLoadInstrumentation(),
    new FetchInstrumentation({
      ignoreUrls: [/sockjs/],
      propagateTraceHeaderCorsUrls: /.*/,
    }),
  ],
});

const loggerProvider = new LoggerProvider({
  resource: resourceFromAttributes({
    'service.name': window.location.hostname === 'cs.justdial.com' ? 'csportal_prod' : 'csportal_dev',
  }),
  processors: [new SimpleLogRecordProcessor(new OTLPLogExporter({ url: logsUrl }))],
});

logs.setGlobalLoggerProvider(loggerProvider);
